import { Card, CardContent } from "@mui/material";
import React from "react";
import UserScoreExpandedView from "./UserScoreExpandedView";

const ExpandedViewOfUserScoreModal = ({
  handleClose,
  projectId,
  userRoleForProject,
  loggedInUser,
}) => {
  return (
    <Card
      sx={{
        bgcolor: "#1B1D28",
        color: "white",
        width: "80vw",
        borderRadius: "10px",
        height: "95vh",
      }}
    >
      <CardContent sx={{ width: "100%" }}>
        <UserScoreExpandedView
          handleClose={handleClose}
          projectId={projectId}
          userRoleForProject={userRoleForProject}
          loggedInUser={loggedInUser}
        />
      </CardContent>
    </Card>
  );
};

export default ExpandedViewOfUserScoreModal;
